module.exports = "/images/logotype-isos.svg?1bebaf2b90e34772c4f66e452b2c4b79";